function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
* 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧
* 🚧                                                                    🚧
* 🚧                      👷これは開発中のコードです。                       🚧
* 🚧                                                                    🚧
* 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧 🚧
*
* 🈲 このファイルを直接編集しないでください。
*  ⚠️ 正式公開の場合は正しい手順でリリースビルドを行なってファイルを最適化してください。
*
*/
(function () {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;

  var __markAsModule = function __markAsModule(target) {
    return __defProp(target, "__esModule", {
      value: true
    });
  };

  var __commonJS = function __commonJS(cb, mod) {
    return function __require() {
      return mod || (0, cb[Object.keys(cb)[0]])((mod = {
        exports: {}
      }).exports, mod), mod.exports;
    };
  };

  var __reExport = function __reExport(target, module, desc) {
    if (module && _typeof(module) === "object" || typeof module === "function") {
      var _iterator = _createForOfIteratorHelper(__getOwnPropNames(module)),
          _step;

      try {
        var _loop = function _loop() {
          var key = _step.value;
          if (!__hasOwnProp.call(target, key) && key !== "default") __defProp(target, key, {
            get: function get() {
              return module[key];
            },
            enumerable: !(desc = __getOwnPropDesc(module, key)) || desc.enumerable
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return target;
  };

  var __toModule = function __toModule(module) {
    return __reExport(__markAsModule(__defProp(module != null ? __create(__getProtoOf(module)) : {}, "default", module && module.__esModule && "default" in module ? {
      get: function get() {
        return module.default;
      },
      enumerable: true
    } : {
      value: module,
      enumerable: true
    })), module);
  }; // node_modules/core-js/internals/to-integer.js


  var require_to_integer = __commonJS({
    "node_modules/core-js/internals/to-integer.js": function node_modulesCoreJsInternalsToIntegerJs(exports, module) {
      var ceil = Math.ceil;
      var floor = Math.floor;

      module.exports = function (argument) {
        return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
      };
    }
  }); // node_modules/core-js/internals/require-object-coercible.js


  var require_require_object_coercible = __commonJS({
    "node_modules/core-js/internals/require-object-coercible.js": function node_modulesCoreJsInternalsRequireObjectCoercibleJs(exports, module) {
      module.exports = function (it) {
        if (it == void 0) throw TypeError("Can't call method on " + it);
        return it;
      };
    }
  }); // node_modules/core-js/internals/string-multibyte.js


  var require_string_multibyte = __commonJS({
    "node_modules/core-js/internals/string-multibyte.js": function node_modulesCoreJsInternalsStringMultibyteJs(exports, module) {
      var toInteger = require_to_integer();
      var requireObjectCoercible = require_require_object_coercible();

      var createMethod = function createMethod(CONVERT_TO_STRING) {
        return function ($this, pos) {
          var S = String(requireObjectCoercible($this));
          var position = toInteger(pos);
          var size = S.length;
          var first, second;
          if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : void 0;
          first = S.charCodeAt(position);
          return first < 55296 || first > 56319 || position + 1 === size || (second = S.charCodeAt(position + 1)) < 56320 || second > 57343 ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 55296 << 10) + (second - 56320) + 65536;
        };
      };

      module.exports = {
        codeAt: createMethod(false),
        charAt: createMethod(true)
      };
    }
  }); // node_modules/core-js/internals/global.js


  var require_global = __commonJS({
    "node_modules/core-js/internals/global.js": function node_modulesCoreJsInternalsGlobalJs(exports, module) {
      var check = function check(it) {
        return it && it.Math == Math && it;
      };

      module.exports = check((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) == "object" && globalThis) || check((typeof window === "undefined" ? "undefined" : _typeof(window)) == "object" && window) || check((typeof self === "undefined" ? "undefined" : _typeof(self)) == "object" && self) || check((typeof global === "undefined" ? "undefined" : _typeof(global)) == "object" && global) || Function("return this")();
    }
  }); // node_modules/core-js/internals/fails.js


  var require_fails = __commonJS({
    "node_modules/core-js/internals/fails.js": function node_modulesCoreJsInternalsFailsJs(exports, module) {
      module.exports = function (exec) {
        try {
          return !!exec();
        } catch (error) {
          return true;
        }
      };
    }
  }); // node_modules/core-js/internals/descriptors.js


  var require_descriptors = __commonJS({
    "node_modules/core-js/internals/descriptors.js": function node_modulesCoreJsInternalsDescriptorsJs(exports, module) {
      var fails = require_fails();
      module.exports = !fails(function () {
        return Object.defineProperty({}, 1, {
          get: function get() {
            return 7;
          }
        })[1] != 7;
      });
    }
  }); // node_modules/core-js/internals/is-object.js


  var require_is_object = __commonJS({
    "node_modules/core-js/internals/is-object.js": function node_modulesCoreJsInternalsIsObjectJs(exports, module) {
      module.exports = function (it) {
        return _typeof(it) === "object" ? it !== null : typeof it === "function";
      };
    }
  }); // node_modules/core-js/internals/document-create-element.js


  var require_document_create_element = __commonJS({
    "node_modules/core-js/internals/document-create-element.js": function node_modulesCoreJsInternalsDocumentCreateElementJs(exports, module) {
      var global2 = require_global();
      var isObject = require_is_object();
      var document2 = global2.document;
      var EXISTS = isObject(document2) && isObject(document2.createElement);

      module.exports = function (it) {
        return EXISTS ? document2.createElement(it) : {};
      };
    }
  }); // node_modules/core-js/internals/ie8-dom-define.js


  var require_ie8_dom_define = __commonJS({
    "node_modules/core-js/internals/ie8-dom-define.js": function node_modulesCoreJsInternalsIe8DomDefineJs(exports, module) {
      var DESCRIPTORS = require_descriptors();
      var fails = require_fails();
      var createElement = require_document_create_element();
      module.exports = !DESCRIPTORS && !fails(function () {
        return Object.defineProperty(createElement("div"), "a", {
          get: function get() {
            return 7;
          }
        }).a != 7;
      });
    }
  }); // node_modules/core-js/internals/an-object.js


  var require_an_object = __commonJS({
    "node_modules/core-js/internals/an-object.js": function node_modulesCoreJsInternalsAnObjectJs(exports, module) {
      var isObject = require_is_object();

      module.exports = function (it) {
        if (!isObject(it)) {
          throw TypeError(String(it) + " is not an object");
        }

        return it;
      };
    }
  }); // node_modules/core-js/internals/to-primitive.js


  var require_to_primitive = __commonJS({
    "node_modules/core-js/internals/to-primitive.js": function node_modulesCoreJsInternalsToPrimitiveJs(exports, module) {
      var isObject = require_is_object();

      module.exports = function (input, PREFERRED_STRING) {
        if (!isObject(input)) return input;
        var fn, val;
        if (PREFERRED_STRING && typeof (fn = input.toString) == "function" && !isObject(val = fn.call(input))) return val;
        if (typeof (fn = input.valueOf) == "function" && !isObject(val = fn.call(input))) return val;
        if (!PREFERRED_STRING && typeof (fn = input.toString) == "function" && !isObject(val = fn.call(input))) return val;
        throw TypeError("Can't convert object to primitive value");
      };
    }
  }); // node_modules/core-js/internals/object-define-property.js


  var require_object_define_property = __commonJS({
    "node_modules/core-js/internals/object-define-property.js": function node_modulesCoreJsInternalsObjectDefinePropertyJs(exports) {
      var DESCRIPTORS = require_descriptors();
      var IE8_DOM_DEFINE = require_ie8_dom_define();
      var anObject = require_an_object();
      var toPrimitive = require_to_primitive();
      var nativeDefineProperty = Object.defineProperty;
      exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (IE8_DOM_DEFINE) try {
          return nativeDefineProperty(O, P, Attributes);
        } catch (error) {}
        if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported");
        if ("value" in Attributes) O[P] = Attributes.value;
        return O;
      };
    }
  }); // node_modules/core-js/internals/create-property-descriptor.js


  var require_create_property_descriptor = __commonJS({
    "node_modules/core-js/internals/create-property-descriptor.js": function node_modulesCoreJsInternalsCreatePropertyDescriptorJs(exports, module) {
      module.exports = function (bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value: value
        };
      };
    }
  }); // node_modules/core-js/internals/create-non-enumerable-property.js


  var require_create_non_enumerable_property = __commonJS({
    "node_modules/core-js/internals/create-non-enumerable-property.js": function node_modulesCoreJsInternalsCreateNonEnumerablePropertyJs(exports, module) {
      var DESCRIPTORS = require_descriptors();
      var definePropertyModule = require_object_define_property();
      var createPropertyDescriptor = require_create_property_descriptor();
      module.exports = DESCRIPTORS ? function (object, key, value) {
        return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
      } : function (object, key, value) {
        object[key] = value;
        return object;
      };
    }
  }); // node_modules/core-js/internals/set-global.js


  var require_set_global = __commonJS({
    "node_modules/core-js/internals/set-global.js": function node_modulesCoreJsInternalsSetGlobalJs(exports, module) {
      var global2 = require_global();
      var createNonEnumerableProperty = require_create_non_enumerable_property();

      module.exports = function (key, value) {
        try {
          createNonEnumerableProperty(global2, key, value);
        } catch (error) {
          global2[key] = value;
        }

        return value;
      };
    }
  }); // node_modules/core-js/internals/shared-store.js


  var require_shared_store = __commonJS({
    "node_modules/core-js/internals/shared-store.js": function node_modulesCoreJsInternalsSharedStoreJs(exports, module) {
      var global2 = require_global();
      var setGlobal = require_set_global();
      var SHARED = "__core-js_shared__";
      var store = global2[SHARED] || setGlobal(SHARED, {});
      module.exports = store;
    }
  }); // node_modules/core-js/internals/inspect-source.js


  var require_inspect_source = __commonJS({
    "node_modules/core-js/internals/inspect-source.js": function node_modulesCoreJsInternalsInspectSourceJs(exports, module) {
      var store = require_shared_store();
      var functionToString = Function.toString;

      if (typeof store.inspectSource != "function") {
        store.inspectSource = function (it) {
          return functionToString.call(it);
        };
      }

      module.exports = store.inspectSource;
    }
  }); // node_modules/core-js/internals/native-weak-map.js


  var require_native_weak_map = __commonJS({
    "node_modules/core-js/internals/native-weak-map.js": function node_modulesCoreJsInternalsNativeWeakMapJs(exports, module) {
      var global2 = require_global();
      var inspectSource = require_inspect_source();
      var WeakMap = global2.WeakMap;
      module.exports = typeof WeakMap === "function" && /native code/.test(inspectSource(WeakMap));
    }
  }); // node_modules/core-js/internals/has.js


  var require_has = __commonJS({
    "node_modules/core-js/internals/has.js": function node_modulesCoreJsInternalsHasJs(exports, module) {
      var hasOwnProperty = {}.hasOwnProperty;

      module.exports = function (it, key) {
        return hasOwnProperty.call(it, key);
      };
    }
  }); // node_modules/core-js/internals/is-pure.js


  var require_is_pure = __commonJS({
    "node_modules/core-js/internals/is-pure.js": function node_modulesCoreJsInternalsIsPureJs(exports, module) {
      module.exports = false;
    }
  }); // node_modules/core-js/internals/shared.js


  var require_shared = __commonJS({
    "node_modules/core-js/internals/shared.js": function node_modulesCoreJsInternalsSharedJs(exports, module) {
      var IS_PURE = require_is_pure();
      var store = require_shared_store();
      (module.exports = function (key, value) {
        return store[key] || (store[key] = value !== void 0 ? value : {});
      })("versions", []).push({
        version: "3.6.5",
        mode: IS_PURE ? "pure" : "global",
        copyright: "\xA9 2020 Denis Pushkarev (zloirock.ru)"
      });
    }
  }); // node_modules/core-js/internals/uid.js


  var require_uid = __commonJS({
    "node_modules/core-js/internals/uid.js": function node_modulesCoreJsInternalsUidJs(exports, module) {
      var id = 0;
      var postfix = Math.random();

      module.exports = function (key) {
        return "Symbol(" + String(key === void 0 ? "" : key) + ")_" + (++id + postfix).toString(36);
      };
    }
  }); // node_modules/core-js/internals/shared-key.js


  var require_shared_key = __commonJS({
    "node_modules/core-js/internals/shared-key.js": function node_modulesCoreJsInternalsSharedKeyJs(exports, module) {
      var shared = require_shared();
      var uid = require_uid();
      var keys = shared("keys");

      module.exports = function (key) {
        return keys[key] || (keys[key] = uid(key));
      };
    }
  }); // node_modules/core-js/internals/hidden-keys.js


  var require_hidden_keys = __commonJS({
    "node_modules/core-js/internals/hidden-keys.js": function node_modulesCoreJsInternalsHiddenKeysJs(exports, module) {
      module.exports = {};
    }
  }); // node_modules/core-js/internals/internal-state.js


  var require_internal_state = __commonJS({
    "node_modules/core-js/internals/internal-state.js": function node_modulesCoreJsInternalsInternalStateJs(exports, module) {
      var NATIVE_WEAK_MAP = require_native_weak_map();
      var global2 = require_global();
      var isObject = require_is_object();
      var createNonEnumerableProperty = require_create_non_enumerable_property();
      var objectHas = require_has();
      var sharedKey = require_shared_key();
      var hiddenKeys = require_hidden_keys();
      var WeakMap = global2.WeakMap;
      var set;
      var get;
      var has;

      var enforce = function enforce(it) {
        return has(it) ? get(it) : set(it, {});
      };

      var getterFor = function getterFor(TYPE) {
        return function (it) {
          var state;

          if (!isObject(it) || (state = get(it)).type !== TYPE) {
            throw TypeError("Incompatible receiver, " + TYPE + " required");
          }

          return state;
        };
      };

      if (NATIVE_WEAK_MAP) {
        store = new WeakMap();
        wmget = store.get;
        wmhas = store.has;
        wmset = store.set;

        set = function set(it, metadata) {
          wmset.call(store, it, metadata);
          return metadata;
        };

        get = function get(it) {
          return wmget.call(store, it) || {};
        };

        has = function has(it) {
          return wmhas.call(store, it);
        };
      } else {
        STATE = sharedKey("state");
        hiddenKeys[STATE] = true;

        set = function set(it, metadata) {
          createNonEnumerableProperty(it, STATE, metadata);
          return metadata;
        };

        get = function get(it) {
          return objectHas(it, STATE) ? it[STATE] : {};
        };

        has = function has(it) {
          return objectHas(it, STATE);
        };
      }

      var store;
      var wmget;
      var wmhas;
      var wmset;
      var STATE;
      module.exports = {
        set: set,
        get: get,
        has: has,
        enforce: enforce,
        getterFor: getterFor
      };
    }
  }); // node_modules/core-js/internals/object-property-is-enumerable.js


  var require_object_property_is_enumerable = __commonJS({
    "node_modules/core-js/internals/object-property-is-enumerable.js": function node_modulesCoreJsInternalsObjectPropertyIsEnumerableJs(exports) {
      "use strict";

      var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
      var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
      var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({
        1: 2
      }, 1);
      exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
        var descriptor = getOwnPropertyDescriptor(this, V);
        return !!descriptor && descriptor.enumerable;
      } : nativePropertyIsEnumerable;
    }
  }); // node_modules/core-js/internals/classof-raw.js


  var require_classof_raw = __commonJS({
    "node_modules/core-js/internals/classof-raw.js": function node_modulesCoreJsInternalsClassofRawJs(exports, module) {
      var toString = {}.toString;

      module.exports = function (it) {
        return toString.call(it).slice(8, -1);
      };
    }
  }); // node_modules/core-js/internals/indexed-object.js


  var require_indexed_object = __commonJS({
    "node_modules/core-js/internals/indexed-object.js": function node_modulesCoreJsInternalsIndexedObjectJs(exports, module) {
      var fails = require_fails();
      var classof = require_classof_raw();
      var split = "".split;
      module.exports = fails(function () {
        return !Object("z").propertyIsEnumerable(0);
      }) ? function (it) {
        return classof(it) == "String" ? split.call(it, "") : Object(it);
      } : Object;
    }
  }); // node_modules/core-js/internals/to-indexed-object.js


  var require_to_indexed_object = __commonJS({
    "node_modules/core-js/internals/to-indexed-object.js": function node_modulesCoreJsInternalsToIndexedObjectJs(exports, module) {
      var IndexedObject = require_indexed_object();
      var requireObjectCoercible = require_require_object_coercible();

      module.exports = function (it) {
        return IndexedObject(requireObjectCoercible(it));
      };
    }
  }); // node_modules/core-js/internals/object-get-own-property-descriptor.js


  var require_object_get_own_property_descriptor = __commonJS({
    "node_modules/core-js/internals/object-get-own-property-descriptor.js": function node_modulesCoreJsInternalsObjectGetOwnPropertyDescriptorJs(exports) {
      var DESCRIPTORS = require_descriptors();
      var propertyIsEnumerableModule = require_object_property_is_enumerable();
      var createPropertyDescriptor = require_create_property_descriptor();
      var toIndexedObject = require_to_indexed_object();
      var toPrimitive = require_to_primitive();
      var has = require_has();
      var IE8_DOM_DEFINE = require_ie8_dom_define();
      var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
      exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
        O = toIndexedObject(O);
        P = toPrimitive(P, true);
        if (IE8_DOM_DEFINE) try {
          return nativeGetOwnPropertyDescriptor(O, P);
        } catch (error) {}
        if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
      };
    }
  }); // node_modules/core-js/internals/redefine.js


  var require_redefine = __commonJS({
    "node_modules/core-js/internals/redefine.js": function node_modulesCoreJsInternalsRedefineJs(exports, module) {
      var global2 = require_global();
      var createNonEnumerableProperty = require_create_non_enumerable_property();
      var has = require_has();
      var setGlobal = require_set_global();
      var inspectSource = require_inspect_source();
      var InternalStateModule = require_internal_state();
      var getInternalState = InternalStateModule.get;
      var enforceInternalState = InternalStateModule.enforce;
      var TEMPLATE = String(String).split("String");
      (module.exports = function (O, key, value, options) {
        var unsafe = options ? !!options.unsafe : false;
        var simple = options ? !!options.enumerable : false;
        var noTargetGet = options ? !!options.noTargetGet : false;

        if (typeof value == "function") {
          if (typeof key == "string" && !has(value, "name")) createNonEnumerableProperty(value, "name", key);
          enforceInternalState(value).source = TEMPLATE.join(typeof key == "string" ? key : "");
        }

        if (O === global2) {
          if (simple) O[key] = value;else setGlobal(key, value);
          return;
        } else if (!unsafe) {
          delete O[key];
        } else if (!noTargetGet && O[key]) {
          simple = true;
        }

        if (simple) O[key] = value;else createNonEnumerableProperty(O, key, value);
      })(Function.prototype, "toString", function toString() {
        return typeof this == "function" && getInternalState(this).source || inspectSource(this);
      });
    }
  }); // node_modules/core-js/internals/path.js


  var require_path = __commonJS({
    "node_modules/core-js/internals/path.js": function node_modulesCoreJsInternalsPathJs(exports, module) {
      var global2 = require_global();
      module.exports = global2;
    }
  }); // node_modules/core-js/internals/get-built-in.js


  var require_get_built_in = __commonJS({
    "node_modules/core-js/internals/get-built-in.js": function node_modulesCoreJsInternalsGetBuiltInJs(exports, module) {
      var path = require_path();
      var global2 = require_global();

      var aFunction = function aFunction(variable) {
        return typeof variable == "function" ? variable : void 0;
      };

      module.exports = function (namespace, method) {
        return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global2[namespace]) : path[namespace] && path[namespace][method] || global2[namespace] && global2[namespace][method];
      };
    }
  }); // node_modules/core-js/internals/to-length.js


  var require_to_length = __commonJS({
    "node_modules/core-js/internals/to-length.js": function node_modulesCoreJsInternalsToLengthJs(exports, module) {
      var toInteger = require_to_integer();
      var min = Math.min;

      module.exports = function (argument) {
        return argument > 0 ? min(toInteger(argument), 9007199254740991) : 0;
      };
    }
  }); // node_modules/core-js/internals/to-absolute-index.js


  var require_to_absolute_index = __commonJS({
    "node_modules/core-js/internals/to-absolute-index.js": function node_modulesCoreJsInternalsToAbsoluteIndexJs(exports, module) {
      var toInteger = require_to_integer();
      var max = Math.max;
      var min = Math.min;

      module.exports = function (index, length) {
        var integer = toInteger(index);
        return integer < 0 ? max(integer + length, 0) : min(integer, length);
      };
    }
  }); // node_modules/core-js/internals/array-includes.js


  var require_array_includes = __commonJS({
    "node_modules/core-js/internals/array-includes.js": function node_modulesCoreJsInternalsArrayIncludesJs(exports, module) {
      var toIndexedObject = require_to_indexed_object();
      var toLength = require_to_length();
      var toAbsoluteIndex = require_to_absolute_index();

      var createMethod = function createMethod(IS_INCLUDES) {
        return function ($this, el, fromIndex) {
          var O = toIndexedObject($this);
          var length = toLength(O.length);
          var index = toAbsoluteIndex(fromIndex, length);
          var value;
          if (IS_INCLUDES && el != el) while (length > index) {
            value = O[index++];
            if (value != value) return true;
          } else for (; length > index; index++) {
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
          }
          return !IS_INCLUDES && -1;
        };
      };

      module.exports = {
        includes: createMethod(true),
        indexOf: createMethod(false)
      };
    }
  }); // node_modules/core-js/internals/object-keys-internal.js


  var require_object_keys_internal = __commonJS({
    "node_modules/core-js/internals/object-keys-internal.js": function node_modulesCoreJsInternalsObjectKeysInternalJs(exports, module) {
      var has = require_has();
      var toIndexedObject = require_to_indexed_object();
      var indexOf = require_array_includes().indexOf;
      var hiddenKeys = require_hidden_keys();

      module.exports = function (object, names) {
        var O = toIndexedObject(object);
        var i = 0;
        var result = [];
        var key;

        for (key in O) {
          !has(hiddenKeys, key) && has(O, key) && result.push(key);
        }

        while (names.length > i) {
          if (has(O, key = names[i++])) {
            ~indexOf(result, key) || result.push(key);
          }
        }

        return result;
      };
    }
  }); // node_modules/core-js/internals/enum-bug-keys.js


  var require_enum_bug_keys = __commonJS({
    "node_modules/core-js/internals/enum-bug-keys.js": function node_modulesCoreJsInternalsEnumBugKeysJs(exports, module) {
      module.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    }
  }); // node_modules/core-js/internals/object-get-own-property-names.js


  var require_object_get_own_property_names = __commonJS({
    "node_modules/core-js/internals/object-get-own-property-names.js": function node_modulesCoreJsInternalsObjectGetOwnPropertyNamesJs(exports) {
      var internalObjectKeys = require_object_keys_internal();
      var enumBugKeys = require_enum_bug_keys();
      var hiddenKeys = enumBugKeys.concat("length", "prototype");

      exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return internalObjectKeys(O, hiddenKeys);
      };
    }
  }); // node_modules/core-js/internals/object-get-own-property-symbols.js


  var require_object_get_own_property_symbols = __commonJS({
    "node_modules/core-js/internals/object-get-own-property-symbols.js": function node_modulesCoreJsInternalsObjectGetOwnPropertySymbolsJs(exports) {
      exports.f = Object.getOwnPropertySymbols;
    }
  }); // node_modules/core-js/internals/own-keys.js


  var require_own_keys = __commonJS({
    "node_modules/core-js/internals/own-keys.js": function node_modulesCoreJsInternalsOwnKeysJs(exports, module) {
      var getBuiltIn = require_get_built_in();
      var getOwnPropertyNamesModule = require_object_get_own_property_names();
      var getOwnPropertySymbolsModule = require_object_get_own_property_symbols();
      var anObject = require_an_object();

      module.exports = getBuiltIn("Reflect", "ownKeys") || function ownKeys(it) {
        var keys = getOwnPropertyNamesModule.f(anObject(it));
        var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
        return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
      };
    }
  }); // node_modules/core-js/internals/copy-constructor-properties.js


  var require_copy_constructor_properties = __commonJS({
    "node_modules/core-js/internals/copy-constructor-properties.js": function node_modulesCoreJsInternalsCopyConstructorPropertiesJs(exports, module) {
      var has = require_has();
      var ownKeys = require_own_keys();
      var getOwnPropertyDescriptorModule = require_object_get_own_property_descriptor();
      var definePropertyModule = require_object_define_property();

      module.exports = function (target, source) {
        var keys = ownKeys(source);
        var defineProperty = definePropertyModule.f;
        var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;

        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
        }
      };
    }
  }); // node_modules/core-js/internals/is-forced.js


  var require_is_forced = __commonJS({
    "node_modules/core-js/internals/is-forced.js": function node_modulesCoreJsInternalsIsForcedJs(exports, module) {
      var fails = require_fails();
      var replacement = /#|\.prototype\./;

      var isForced = function isForced(feature, detection) {
        var value = data[normalize(feature)];
        return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == "function" ? fails(detection) : !!detection;
      };

      var normalize = isForced.normalize = function (string) {
        return String(string).replace(replacement, ".").toLowerCase();
      };

      var data = isForced.data = {};
      var NATIVE = isForced.NATIVE = "N";
      var POLYFILL = isForced.POLYFILL = "P";
      module.exports = isForced;
    }
  }); // node_modules/core-js/internals/export.js


  var require_export = __commonJS({
    "node_modules/core-js/internals/export.js": function node_modulesCoreJsInternalsExportJs(exports, module) {
      var global2 = require_global();
      var getOwnPropertyDescriptor = require_object_get_own_property_descriptor().f;
      var createNonEnumerableProperty = require_create_non_enumerable_property();
      var redefine = require_redefine();
      var setGlobal = require_set_global();
      var copyConstructorProperties = require_copy_constructor_properties();
      var isForced = require_is_forced();

      module.exports = function (options, source) {
        var TARGET = options.target;
        var GLOBAL = options.global;
        var STATIC = options.stat;
        var FORCED, target, key, targetProperty, sourceProperty, descriptor;

        if (GLOBAL) {
          target = global2;
        } else if (STATIC) {
          target = global2[TARGET] || setGlobal(TARGET, {});
        } else {
          target = (global2[TARGET] || {}).prototype;
        }

        if (target) for (key in source) {
          sourceProperty = source[key];

          if (options.noTargetGet) {
            descriptor = getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
          } else targetProperty = target[key];

          FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);

          if (!FORCED && targetProperty !== void 0) {
            if (_typeof(sourceProperty) === _typeof(targetProperty)) continue;
            copyConstructorProperties(sourceProperty, targetProperty);
          }

          if (options.sham || targetProperty && targetProperty.sham) {
            createNonEnumerableProperty(sourceProperty, "sham", true);
          }

          redefine(target, key, sourceProperty, options);
        }
      };
    }
  }); // node_modules/core-js/internals/to-object.js


  var require_to_object = __commonJS({
    "node_modules/core-js/internals/to-object.js": function node_modulesCoreJsInternalsToObjectJs(exports, module) {
      var requireObjectCoercible = require_require_object_coercible();

      module.exports = function (argument) {
        return Object(requireObjectCoercible(argument));
      };
    }
  }); // node_modules/core-js/internals/correct-prototype-getter.js


  var require_correct_prototype_getter = __commonJS({
    "node_modules/core-js/internals/correct-prototype-getter.js": function node_modulesCoreJsInternalsCorrectPrototypeGetterJs(exports, module) {
      var fails = require_fails();
      module.exports = !fails(function () {
        function F() {}

        F.prototype.constructor = null;
        return Object.getPrototypeOf(new F()) !== F.prototype;
      });
    }
  }); // node_modules/core-js/internals/object-get-prototype-of.js


  var require_object_get_prototype_of = __commonJS({
    "node_modules/core-js/internals/object-get-prototype-of.js": function node_modulesCoreJsInternalsObjectGetPrototypeOfJs(exports, module) {
      var has = require_has();
      var toObject = require_to_object();
      var sharedKey = require_shared_key();
      var CORRECT_PROTOTYPE_GETTER = require_correct_prototype_getter();
      var IE_PROTO = sharedKey("IE_PROTO");
      var ObjectPrototype = Object.prototype;
      module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
        O = toObject(O);
        if (has(O, IE_PROTO)) return O[IE_PROTO];

        if (typeof O.constructor == "function" && O instanceof O.constructor) {
          return O.constructor.prototype;
        }

        return O instanceof Object ? ObjectPrototype : null;
      };
    }
  }); // node_modules/core-js/internals/native-symbol.js


  var require_native_symbol = __commonJS({
    "node_modules/core-js/internals/native-symbol.js": function node_modulesCoreJsInternalsNativeSymbolJs(exports, module) {
      var fails = require_fails();
      module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
        return !String(Symbol());
      });
    }
  }); // node_modules/core-js/internals/use-symbol-as-uid.js


  var require_use_symbol_as_uid = __commonJS({
    "node_modules/core-js/internals/use-symbol-as-uid.js": function node_modulesCoreJsInternalsUseSymbolAsUidJs(exports, module) {
      var NATIVE_SYMBOL = require_native_symbol();
      module.exports = NATIVE_SYMBOL && !Symbol.sham && _typeof(Symbol.iterator) == "symbol";
    }
  }); // node_modules/core-js/internals/well-known-symbol.js


  var require_well_known_symbol = __commonJS({
    "node_modules/core-js/internals/well-known-symbol.js": function node_modulesCoreJsInternalsWellKnownSymbolJs(exports, module) {
      var global2 = require_global();
      var shared = require_shared();
      var has = require_has();
      var uid = require_uid();
      var NATIVE_SYMBOL = require_native_symbol();
      var USE_SYMBOL_AS_UID = require_use_symbol_as_uid();
      var WellKnownSymbolsStore = shared("wks");
      var Symbol2 = global2.Symbol;
      var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol2 : Symbol2 && Symbol2.withoutSetter || uid;

      module.exports = function (name) {
        if (!has(WellKnownSymbolsStore, name)) {
          if (NATIVE_SYMBOL && has(Symbol2, name)) WellKnownSymbolsStore[name] = Symbol2[name];else WellKnownSymbolsStore[name] = createWellKnownSymbol("Symbol." + name);
        }

        return WellKnownSymbolsStore[name];
      };
    }
  }); // node_modules/core-js/internals/iterators-core.js


  var require_iterators_core = __commonJS({
    "node_modules/core-js/internals/iterators-core.js": function node_modulesCoreJsInternalsIteratorsCoreJs(exports, module) {
      "use strict";

      var getPrototypeOf = require_object_get_prototype_of();
      var createNonEnumerableProperty = require_create_non_enumerable_property();
      var has = require_has();
      var wellKnownSymbol = require_well_known_symbol();
      var IS_PURE = require_is_pure();
      var ITERATOR = wellKnownSymbol("iterator");
      var BUGGY_SAFARI_ITERATORS = false;

      var returnThis = function returnThis() {
        return this;
      };

      var IteratorPrototype;
      var PrototypeOfArrayIteratorPrototype;
      var arrayIterator;

      if ([].keys) {
        arrayIterator = [].keys();
        if (!("next" in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
          PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
          if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
        }
      }

      if (IteratorPrototype == void 0) IteratorPrototype = {};

      if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
        createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
      }

      module.exports = {
        IteratorPrototype: IteratorPrototype,
        BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
      };
    }
  }); // node_modules/core-js/internals/object-keys.js


  var require_object_keys = __commonJS({
    "node_modules/core-js/internals/object-keys.js": function node_modulesCoreJsInternalsObjectKeysJs(exports, module) {
      var internalObjectKeys = require_object_keys_internal();
      var enumBugKeys = require_enum_bug_keys();

      module.exports = Object.keys || function keys(O) {
        return internalObjectKeys(O, enumBugKeys);
      };
    }
  }); // node_modules/core-js/internals/object-define-properties.js


  var require_object_define_properties = __commonJS({
    "node_modules/core-js/internals/object-define-properties.js": function node_modulesCoreJsInternalsObjectDefinePropertiesJs(exports, module) {
      var DESCRIPTORS = require_descriptors();
      var definePropertyModule = require_object_define_property();
      var anObject = require_an_object();
      var objectKeys = require_object_keys();
      module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject(O);
        var keys = objectKeys(Properties);
        var length = keys.length;
        var index = 0;
        var key;

        while (length > index) {
          definePropertyModule.f(O, key = keys[index++], Properties[key]);
        }

        return O;
      };
    }
  }); // node_modules/core-js/internals/html.js


  var require_html = __commonJS({
    "node_modules/core-js/internals/html.js": function node_modulesCoreJsInternalsHtmlJs(exports, module) {
      var getBuiltIn = require_get_built_in();
      module.exports = getBuiltIn("document", "documentElement");
    }
  }); // node_modules/core-js/internals/object-create.js


  var require_object_create = __commonJS({
    "node_modules/core-js/internals/object-create.js": function node_modulesCoreJsInternalsObjectCreateJs(exports, module) {
      var anObject = require_an_object();
      var defineProperties = require_object_define_properties();
      var enumBugKeys = require_enum_bug_keys();
      var hiddenKeys = require_hidden_keys();
      var html = require_html();
      var documentCreateElement = require_document_create_element();
      var sharedKey = require_shared_key();
      var GT = ">";
      var LT = "<";
      var PROTOTYPE = "prototype";
      var SCRIPT = "script";
      var IE_PROTO = sharedKey("IE_PROTO");

      var EmptyConstructor = function EmptyConstructor() {};

      var scriptTag = function scriptTag(content) {
        return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
      };

      var NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument2) {
        activeXDocument2.write(scriptTag(""));
        activeXDocument2.close();
        var temp = activeXDocument2.parentWindow.Object;
        activeXDocument2 = null;
        return temp;
      };

      var NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
        var iframe = documentCreateElement("iframe");
        var JS = "java" + SCRIPT + ":";
        var iframeDocument;
        iframe.style.display = "none";
        html.appendChild(iframe);
        iframe.src = String(JS);
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(scriptTag("document.F=Object"));
        iframeDocument.close();
        return iframeDocument.F;
      };

      var activeXDocument;

      var _NullProtoObject = function NullProtoObject() {
        try {
          activeXDocument = document.domain && new ActiveXObject("htmlfile");
        } catch (error) {}

        _NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
        var length = enumBugKeys.length;

        while (length--) {
          delete _NullProtoObject[PROTOTYPE][enumBugKeys[length]];
        }

        return _NullProtoObject();
      };

      hiddenKeys[IE_PROTO] = true;

      module.exports = Object.create || function create(O, Properties) {
        var result;

        if (O !== null) {
          EmptyConstructor[PROTOTYPE] = anObject(O);
          result = new EmptyConstructor();
          EmptyConstructor[PROTOTYPE] = null;
          result[IE_PROTO] = O;
        } else result = _NullProtoObject();

        return Properties === void 0 ? result : defineProperties(result, Properties);
      };
    }
  }); // node_modules/core-js/internals/set-to-string-tag.js


  var require_set_to_string_tag = __commonJS({
    "node_modules/core-js/internals/set-to-string-tag.js": function node_modulesCoreJsInternalsSetToStringTagJs(exports, module) {
      var defineProperty = require_object_define_property().f;
      var has = require_has();
      var wellKnownSymbol = require_well_known_symbol();
      var TO_STRING_TAG = wellKnownSymbol("toStringTag");

      module.exports = function (it, TAG, STATIC) {
        if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
          defineProperty(it, TO_STRING_TAG, {
            configurable: true,
            value: TAG
          });
        }
      };
    }
  }); // node_modules/core-js/internals/iterators.js


  var require_iterators = __commonJS({
    "node_modules/core-js/internals/iterators.js": function node_modulesCoreJsInternalsIteratorsJs(exports, module) {
      module.exports = {};
    }
  }); // node_modules/core-js/internals/create-iterator-constructor.js


  var require_create_iterator_constructor = __commonJS({
    "node_modules/core-js/internals/create-iterator-constructor.js": function node_modulesCoreJsInternalsCreateIteratorConstructorJs(exports, module) {
      "use strict";

      var IteratorPrototype = require_iterators_core().IteratorPrototype;
      var create = require_object_create();
      var createPropertyDescriptor = require_create_property_descriptor();
      var setToStringTag = require_set_to_string_tag();
      var Iterators = require_iterators();

      var returnThis = function returnThis() {
        return this;
      };

      module.exports = function (IteratorConstructor, NAME, next) {
        var TO_STRING_TAG = NAME + " Iterator";
        IteratorConstructor.prototype = create(IteratorPrototype, {
          next: createPropertyDescriptor(1, next)
        });
        setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
        Iterators[TO_STRING_TAG] = returnThis;
        return IteratorConstructor;
      };
    }
  }); // node_modules/core-js/internals/a-possible-prototype.js


  var require_a_possible_prototype = __commonJS({
    "node_modules/core-js/internals/a-possible-prototype.js": function node_modulesCoreJsInternalsAPossiblePrototypeJs(exports, module) {
      var isObject = require_is_object();

      module.exports = function (it) {
        if (!isObject(it) && it !== null) {
          throw TypeError("Can't set " + String(it) + " as a prototype");
        }

        return it;
      };
    }
  }); // node_modules/core-js/internals/object-set-prototype-of.js


  var require_object_set_prototype_of = __commonJS({
    "node_modules/core-js/internals/object-set-prototype-of.js": function node_modulesCoreJsInternalsObjectSetPrototypeOfJs(exports, module) {
      var anObject = require_an_object();
      var aPossiblePrototype = require_a_possible_prototype();
      module.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
        var CORRECT_SETTER = false;
        var test = {};
        var setter;

        try {
          setter = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set;
          setter.call(test, []);
          CORRECT_SETTER = test instanceof Array;
        } catch (error) {}

        return function setPrototypeOf(O, proto) {
          anObject(O);
          aPossiblePrototype(proto);
          if (CORRECT_SETTER) setter.call(O, proto);else O.__proto__ = proto;
          return O;
        };
      }() : void 0);
    }
  }); // node_modules/core-js/internals/define-iterator.js


  var require_define_iterator = __commonJS({
    "node_modules/core-js/internals/define-iterator.js": function node_modulesCoreJsInternalsDefineIteratorJs(exports, module) {
      "use strict";

      var $2 = require_export();
      var createIteratorConstructor = require_create_iterator_constructor();
      var getPrototypeOf = require_object_get_prototype_of();
      var setPrototypeOf = require_object_set_prototype_of();
      var setToStringTag = require_set_to_string_tag();
      var createNonEnumerableProperty = require_create_non_enumerable_property();
      var redefine = require_redefine();
      var wellKnownSymbol = require_well_known_symbol();
      var IS_PURE = require_is_pure();
      var Iterators = require_iterators();
      var IteratorsCore = require_iterators_core();
      var IteratorPrototype = IteratorsCore.IteratorPrototype;
      var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
      var ITERATOR = wellKnownSymbol("iterator");
      var KEYS = "keys";
      var VALUES = "values";
      var ENTRIES = "entries";

      var returnThis = function returnThis() {
        return this;
      };

      module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
        createIteratorConstructor(IteratorConstructor, NAME, next);

        var getIterationMethod = function getIterationMethod(KIND) {
          if (KIND === DEFAULT && defaultIterator) return defaultIterator;
          if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];

          switch (KIND) {
            case KEYS:
              return function keys() {
                return new IteratorConstructor(this, KIND);
              };

            case VALUES:
              return function values() {
                return new IteratorConstructor(this, KIND);
              };

            case ENTRIES:
              return function entries() {
                return new IteratorConstructor(this, KIND);
              };
          }

          return function () {
            return new IteratorConstructor(this);
          };
        };

        var TO_STRING_TAG = NAME + " Iterator";
        var INCORRECT_VALUES_NAME = false;
        var IterablePrototype = Iterable.prototype;
        var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
        var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
        var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
        var CurrentIteratorPrototype, methods, KEY;

        if (anyNativeIterator) {
          CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));

          if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
              if (setPrototypeOf) {
                setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
              } else if (typeof CurrentIteratorPrototype[ITERATOR] != "function") {
                createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
              }
            }

            setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
          }
        }

        if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
          INCORRECT_VALUES_NAME = true;

          defaultIterator = function values() {
            return nativeIterator.call(this);
          };
        }

        if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
          createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
        }

        Iterators[NAME] = defaultIterator;

        if (DEFAULT) {
          methods = {
            values: getIterationMethod(VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
            entries: getIterationMethod(ENTRIES)
          };
          if (FORCED) for (KEY in methods) {
            if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
              redefine(IterablePrototype, KEY, methods[KEY]);
            }
          } else $2({
            target: NAME,
            proto: true,
            forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
          }, methods);
        }

        return methods;
      };
    }
  }); // node_modules/core-js/modules/es.string.iterator.js


  var require_es_string_iterator = __commonJS({
    "node_modules/core-js/modules/es.string.iterator.js": function node_modulesCoreJsModulesEsStringIteratorJs() {
      "use strict";

      var charAt = require_string_multibyte().charAt;
      var InternalStateModule = require_internal_state();
      var defineIterator = require_define_iterator();
      var STRING_ITERATOR = "String Iterator";
      var setInternalState = InternalStateModule.set;
      var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
      defineIterator(String, "String", function (iterated) {
        setInternalState(this, {
          type: STRING_ITERATOR,
          string: String(iterated),
          index: 0
        });
      }, function next() {
        var state = getInternalState(this);
        var string = state.string;
        var index = state.index;
        var point;
        if (index >= string.length) return {
          value: void 0,
          done: true
        };
        point = charAt(string, index);
        state.index += point.length;
        return {
          value: point,
          done: false
        };
      });
    }
  }); // node_modules/core-js/internals/a-function.js


  var require_a_function = __commonJS({
    "node_modules/core-js/internals/a-function.js": function node_modulesCoreJsInternalsAFunctionJs(exports, module) {
      module.exports = function (it) {
        if (typeof it != "function") {
          throw TypeError(String(it) + " is not a function");
        }

        return it;
      };
    }
  }); // node_modules/core-js/internals/function-bind-context.js


  var require_function_bind_context = __commonJS({
    "node_modules/core-js/internals/function-bind-context.js": function node_modulesCoreJsInternalsFunctionBindContextJs(exports, module) {
      var aFunction = require_a_function();

      module.exports = function (fn, that, length) {
        aFunction(fn);
        if (that === void 0) return fn;

        switch (length) {
          case 0:
            return function () {
              return fn.call(that);
            };

          case 1:
            return function (a) {
              return fn.call(that, a);
            };

          case 2:
            return function (a, b) {
              return fn.call(that, a, b);
            };

          case 3:
            return function (a, b, c) {
              return fn.call(that, a, b, c);
            };
        }

        return function () {
          return fn.apply(that, arguments);
        };
      };
    }
  }); // node_modules/core-js/internals/call-with-safe-iteration-closing.js


  var require_call_with_safe_iteration_closing = __commonJS({
    "node_modules/core-js/internals/call-with-safe-iteration-closing.js": function node_modulesCoreJsInternalsCallWithSafeIterationClosingJs(exports, module) {
      var anObject = require_an_object();

      module.exports = function (iterator, fn, value, ENTRIES) {
        try {
          return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
        } catch (error) {
          var returnMethod = iterator["return"];
          if (returnMethod !== void 0) anObject(returnMethod.call(iterator));
          throw error;
        }
      };
    }
  }); // node_modules/core-js/internals/is-array-iterator-method.js


  var require_is_array_iterator_method = __commonJS({
    "node_modules/core-js/internals/is-array-iterator-method.js": function node_modulesCoreJsInternalsIsArrayIteratorMethodJs(exports, module) {
      var wellKnownSymbol = require_well_known_symbol();
      var Iterators = require_iterators();
      var ITERATOR = wellKnownSymbol("iterator");
      var ArrayPrototype = Array.prototype;

      module.exports = function (it) {
        return it !== void 0 && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
      };
    }
  }); // node_modules/core-js/internals/create-property.js


  var require_create_property = __commonJS({
    "node_modules/core-js/internals/create-property.js": function node_modulesCoreJsInternalsCreatePropertyJs(exports, module) {
      "use strict";

      var toPrimitive = require_to_primitive();
      var definePropertyModule = require_object_define_property();
      var createPropertyDescriptor = require_create_property_descriptor();

      module.exports = function (object, key, value) {
        var propertyKey = toPrimitive(key);
        if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
      };
    }
  }); // node_modules/core-js/internals/to-string-tag-support.js


  var require_to_string_tag_support = __commonJS({
    "node_modules/core-js/internals/to-string-tag-support.js": function node_modulesCoreJsInternalsToStringTagSupportJs(exports, module) {
      var wellKnownSymbol = require_well_known_symbol();
      var TO_STRING_TAG = wellKnownSymbol("toStringTag");
      var test = {};
      test[TO_STRING_TAG] = "z";
      module.exports = String(test) === "[object z]";
    }
  }); // node_modules/core-js/internals/classof.js


  var require_classof = __commonJS({
    "node_modules/core-js/internals/classof.js": function node_modulesCoreJsInternalsClassofJs(exports, module) {
      var TO_STRING_TAG_SUPPORT = require_to_string_tag_support();
      var classofRaw = require_classof_raw();
      var wellKnownSymbol = require_well_known_symbol();
      var TO_STRING_TAG = wellKnownSymbol("toStringTag");
      var CORRECT_ARGUMENTS = classofRaw(function () {
        return arguments;
      }()) == "Arguments";

      var tryGet = function tryGet(it, key) {
        try {
          return it[key];
        } catch (error) {}
      };

      module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
        var O, tag, result;
        return it === void 0 ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == "Object" && typeof O.callee == "function" ? "Arguments" : result;
      };
    }
  }); // node_modules/core-js/internals/get-iterator-method.js


  var require_get_iterator_method = __commonJS({
    "node_modules/core-js/internals/get-iterator-method.js": function node_modulesCoreJsInternalsGetIteratorMethodJs(exports, module) {
      var classof = require_classof();
      var Iterators = require_iterators();
      var wellKnownSymbol = require_well_known_symbol();
      var ITERATOR = wellKnownSymbol("iterator");

      module.exports = function (it) {
        if (it != void 0) return it[ITERATOR] || it["@@iterator"] || Iterators[classof(it)];
      };
    }
  }); // node_modules/core-js/internals/array-from.js


  var require_array_from = __commonJS({
    "node_modules/core-js/internals/array-from.js": function node_modulesCoreJsInternalsArrayFromJs(exports, module) {
      "use strict";

      var bind = require_function_bind_context();
      var toObject = require_to_object();
      var callWithSafeIterationClosing = require_call_with_safe_iteration_closing();
      var isArrayIteratorMethod = require_is_array_iterator_method();
      var toLength = require_to_length();
      var createProperty = require_create_property();
      var getIteratorMethod = require_get_iterator_method();

      module.exports = function from(arrayLike) {
        var O = toObject(arrayLike);
        var C = typeof this == "function" ? this : Array;
        var argumentsLength = arguments.length;
        var mapfn = argumentsLength > 1 ? arguments[1] : void 0;
        var mapping = mapfn !== void 0;
        var iteratorMethod = getIteratorMethod(O);
        var index = 0;
        var length, result, step, iterator, next, value;
        if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : void 0, 2);

        if (iteratorMethod != void 0 && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
          iterator = iteratorMethod.call(O);
          next = iterator.next;
          result = new C();

          for (; !(step = next.call(iterator)).done; index++) {
            value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
            createProperty(result, index, value);
          }
        } else {
          length = toLength(O.length);
          result = new C(length);

          for (; length > index; index++) {
            value = mapping ? mapfn(O[index], index) : O[index];
            createProperty(result, index, value);
          }
        }

        result.length = index;
        return result;
      };
    }
  }); // node_modules/core-js/internals/check-correctness-of-iteration.js


  var require_check_correctness_of_iteration = __commonJS({
    "node_modules/core-js/internals/check-correctness-of-iteration.js": function node_modulesCoreJsInternalsCheckCorrectnessOfIterationJs(exports, module) {
      var wellKnownSymbol = require_well_known_symbol();
      var ITERATOR = wellKnownSymbol("iterator");
      var SAFE_CLOSING = false;

      try {
        called = 0;
        iteratorWithReturn = {
          next: function next() {
            return {
              done: !!called++
            };
          },
          "return": function _return() {
            SAFE_CLOSING = true;
          }
        };

        iteratorWithReturn[ITERATOR] = function () {
          return this;
        };

        Array.from(iteratorWithReturn, function () {
          throw 2;
        });
      } catch (error) {}

      var called;
      var iteratorWithReturn;

      module.exports = function (exec, SKIP_CLOSING) {
        if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
        var ITERATION_SUPPORT = false;

        try {
          var object = {};

          object[ITERATOR] = function () {
            return {
              next: function next() {
                return {
                  done: ITERATION_SUPPORT = true
                };
              }
            };
          };

          exec(object);
        } catch (error) {}

        return ITERATION_SUPPORT;
      };
    }
  }); // node_modules/core-js/modules/es.array.from.js


  var require_es_array_from = __commonJS({
    "node_modules/core-js/modules/es.array.from.js": function node_modulesCoreJsModulesEsArrayFromJs() {
      var $2 = require_export();
      var from = require_array_from();
      var checkCorrectnessOfIteration = require_check_correctness_of_iteration();
      var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
        Array.from(iterable);
      });
      $2({
        target: "Array",
        stat: true,
        forced: INCORRECT_ITERATION
      }, {
        from: from
      });
    }
  }); // node_modules/core-js/es/array/from.js


  var require_from = __commonJS({
    "node_modules/core-js/es/array/from.js": function node_modulesCoreJsEsArrayFromJs(exports, module) {
      require_es_string_iterator();
      require_es_array_from();
      var path = require_path();
      module.exports = path.Array.from;
    }
  }); // node_modules/object-fit-images/dist/ofi.common-js.js


  var require_ofi_common_js = __commonJS({
    "node_modules/object-fit-images/dist/ofi.common-js.js": function node_modulesObjectFitImagesDistOfiCommonJsJs(exports, module) {
      "use strict";

      var OFI = "bfred-it:object-fit-images";
      var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
      var testImg = typeof Image === "undefined" ? {
        style: {
          "object-position": 1
        }
      } : new Image();
      var supportsObjectFit = ("object-fit" in testImg.style);
      var supportsObjectPosition = ("object-position" in testImg.style);
      var supportsOFI = ("background-size" in testImg.style);
      var supportsCurrentSrc = typeof testImg.currentSrc === "string";
      var nativeGetAttribute = testImg.getAttribute;
      var nativeSetAttribute = testImg.setAttribute;
      var autoModeEnabled = false;

      function createPlaceholder(w, h) {
        return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E";
      }

      function polyfillCurrentSrc(el) {
        if (el.srcset && !supportsCurrentSrc && window.picturefill) {
          var pf = window.picturefill._;

          if (!el[pf.ns] || !el[pf.ns].evaled) {
            pf.fillImg(el, {
              reselect: true
            });
          }

          if (!el[pf.ns].curSrc) {
            el[pf.ns].supported = false;
            pf.fillImg(el, {
              reselect: true
            });
          }

          el.currentSrc = el[pf.ns].curSrc || el.src;
        }
      }

      function getStyle(el) {
        var style = getComputedStyle(el).fontFamily;
        var parsed;
        var props = {};

        while ((parsed = propRegex.exec(style)) !== null) {
          props[parsed[1]] = parsed[2];
        }

        return props;
      }

      function setPlaceholder(img, width, height) {
        var placeholder = createPlaceholder(width || 1, height || 0);

        if (nativeGetAttribute.call(img, "src") !== placeholder) {
          nativeSetAttribute.call(img, "src", placeholder);
        }
      }

      function onImageReady(img, callback) {
        if (img.naturalWidth) {
          callback(img);
        } else {
          setTimeout(onImageReady, 100, img, callback);
        }
      }

      function fixOne(el) {
        var style = getStyle(el);
        var ofi = el[OFI];
        style["object-fit"] = style["object-fit"] || "fill";

        if (!ofi.img) {
          if (style["object-fit"] === "fill") {
            return;
          }

          if (!ofi.skipTest && supportsObjectFit && !style["object-position"]) {
            return;
          }
        }

        if (!ofi.img) {
          ofi.img = new Image(el.width, el.height);
          ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
          ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;
          nativeSetAttribute.call(el, "data-ofi-src", el.src);

          if (el.srcset) {
            nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
          }

          setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

          if (el.srcset) {
            el.srcset = "";
          }

          try {
            keepSrcUsable(el);
          } catch (err) {
            if (window.console) {
              console.warn("https://bit.ly/ofi-old-browser");
            }
          }
        }

        polyfillCurrentSrc(ofi.img);
        el.style.backgroundImage = 'url("' + (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') + '")';
        el.style.backgroundPosition = style["object-position"] || "center";
        el.style.backgroundRepeat = "no-repeat";
        el.style.backgroundOrigin = "content-box";

        if (/scale-down/.test(style["object-fit"])) {
          onImageReady(ofi.img, function () {
            if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
              el.style.backgroundSize = "contain";
            } else {
              el.style.backgroundSize = "auto";
            }
          });
        } else {
          el.style.backgroundSize = style["object-fit"].replace("none", "auto").replace("fill", "100% 100%");
        }

        onImageReady(ofi.img, function (img) {
          setPlaceholder(el, img.naturalWidth, img.naturalHeight);
        });
      }

      function keepSrcUsable(el) {
        var descriptors = {
          get: function get(prop) {
            return el[OFI].img[prop ? prop : "src"];
          },
          set: function set(value, prop) {
            el[OFI].img[prop ? prop : "src"] = value;
            nativeSetAttribute.call(el, "data-ofi-" + prop, value);
            fixOne(el);
            return value;
          }
        };
        Object.defineProperty(el, "src", descriptors);
        Object.defineProperty(el, "currentSrc", {
          get: function get() {
            return descriptors.get("currentSrc");
          }
        });
        Object.defineProperty(el, "srcset", {
          get: function get() {
            return descriptors.get("srcset");
          },
          set: function set(ss) {
            return descriptors.set(ss, "srcset");
          }
        });
      }

      function hijackAttributes() {
        function getOfiImageMaybe(el, name) {
          return el[OFI] && el[OFI].img && (name === "src" || name === "srcset") ? el[OFI].img : el;
        }

        if (!supportsObjectPosition) {
          HTMLImageElement.prototype.getAttribute = function (name) {
            return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
          };

          HTMLImageElement.prototype.setAttribute = function (name, value) {
            return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
          };
        }
      }

      function fix(imgs, opts) {
        var startAutoMode = !autoModeEnabled && !imgs;
        opts = opts || {};
        imgs = imgs || "img";

        if (supportsObjectPosition && !opts.skipTest || !supportsOFI) {
          return false;
        }

        if (imgs === "img") {
          imgs = document.getElementsByTagName("img");
        } else if (typeof imgs === "string") {
          imgs = document.querySelectorAll(imgs);
        } else if (!("length" in imgs)) {
          imgs = [imgs];
        }

        for (var i = 0; i < imgs.length; i++) {
          imgs[i][OFI] = imgs[i][OFI] || {
            skipTest: opts.skipTest
          };
          fixOne(imgs[i]);
        }

        if (startAutoMode) {
          document.body.addEventListener("load", function (e) {
            if (e.target.tagName === "IMG") {
              fix(e.target, {
                skipTest: opts.skipTest
              });
            }
          }, true);
          autoModeEnabled = true;
          imgs = "img";
        }

        if (opts.watchMQ) {
          window.addEventListener("resize", fix.bind(null, imgs, {
            skipTest: opts.skipTest
          }));
        }
      }

      fix.supportsObjectFit = supportsObjectFit;
      fix.supportsObjectPosition = supportsObjectPosition;
      hijackAttributes();
      module.exports = fix;
    }
  }); // node_modules/intersection-observer/intersection-observer.js


  var require_intersection_observer = __commonJS({
    "node_modules/intersection-observer/intersection-observer.js": function node_modulesIntersectionObserverIntersectionObserverJs() {
      (function () {
        "use strict";

        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== "object") {
          return;
        }

        if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
          if (!("isIntersecting" in window.IntersectionObserverEntry.prototype)) {
            Object.defineProperty(window.IntersectionObserverEntry.prototype, "isIntersecting", {
              get: function get() {
                return this.intersectionRatio > 0;
              }
            });
          }

          return;
        }

        function getFrameElement(doc) {
          try {
            return doc.defaultView && doc.defaultView.frameElement || null;
          } catch (e) {
            return null;
          }
        }

        var document2 = function (startDoc) {
          var doc = startDoc;
          var frame = getFrameElement(doc);

          while (frame) {
            doc = frame.ownerDocument;
            frame = getFrameElement(doc);
          }

          return doc;
        }(window.document);

        var registry = [];
        var crossOriginUpdater = null;
        var crossOriginRect = null;

        function IntersectionObserverEntry(entry) {
          this.time = entry.time;
          this.target = entry.target;
          this.rootBounds = ensureDOMRect(entry.rootBounds);
          this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
          this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
          this.isIntersecting = !!entry.intersectionRect;
          var targetRect = this.boundingClientRect;
          var targetArea = targetRect.width * targetRect.height;
          var intersectionRect = this.intersectionRect;
          var intersectionArea = intersectionRect.width * intersectionRect.height;

          if (targetArea) {
            this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
          } else {
            this.intersectionRatio = this.isIntersecting ? 1 : 0;
          }
        }

        function IntersectionObserver(callback, opt_options) {
          var options = opt_options || {};

          if (typeof callback != "function") {
            throw new Error("callback must be a function");
          }

          if (options.root && options.root.nodeType != 1 && options.root.nodeType != 9) {
            throw new Error("root must be a Document or Element");
          }

          this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
          this._callback = callback;
          this._observationTargets = [];
          this._queuedEntries = [];
          this._rootMarginValues = this._parseRootMargin(options.rootMargin);
          this.thresholds = this._initThresholds(options.threshold);
          this.root = options.root || null;
          this.rootMargin = this._rootMarginValues.map(function (margin) {
            return margin.value + margin.unit;
          }).join(" ");
          this._monitoringDocuments = [];
          this._monitoringUnsubscribes = [];
        }

        IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
        IntersectionObserver.prototype.POLL_INTERVAL = null;
        IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;

        IntersectionObserver._setupCrossOriginUpdater = function () {
          if (!crossOriginUpdater) {
            crossOriginUpdater = function crossOriginUpdater(boundingClientRect, intersectionRect) {
              if (!boundingClientRect || !intersectionRect) {
                crossOriginRect = getEmptyRect();
              } else {
                crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
              }

              registry.forEach(function (observer) {
                observer._checkForIntersections();
              });
            };
          }

          return crossOriginUpdater;
        };

        IntersectionObserver._resetCrossOriginUpdater = function () {
          crossOriginUpdater = null;
          crossOriginRect = null;
        };

        IntersectionObserver.prototype.observe = function (target) {
          var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
            return item.element == target;
          });

          if (isTargetAlreadyObserved) {
            return;
          }

          if (!(target && target.nodeType == 1)) {
            throw new Error("target must be an Element");
          }

          this._registerInstance();

          this._observationTargets.push({
            element: target,
            entry: null
          });

          this._monitorIntersections(target.ownerDocument);

          this._checkForIntersections();
        };

        IntersectionObserver.prototype.unobserve = function (target) {
          this._observationTargets = this._observationTargets.filter(function (item) {
            return item.element != target;
          });

          this._unmonitorIntersections(target.ownerDocument);

          if (this._observationTargets.length == 0) {
            this._unregisterInstance();
          }
        };

        IntersectionObserver.prototype.disconnect = function () {
          this._observationTargets = [];

          this._unmonitorAllIntersections();

          this._unregisterInstance();
        };

        IntersectionObserver.prototype.takeRecords = function () {
          var records = this._queuedEntries.slice();

          this._queuedEntries = [];
          return records;
        };

        IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
          var threshold = opt_threshold || [0];
          if (!Array.isArray(threshold)) threshold = [threshold];
          return threshold.sort().filter(function (t, i, a) {
            if (typeof t != "number" || isNaN(t) || t < 0 || t > 1) {
              throw new Error("threshold must be a number between 0 and 1 inclusively");
            }

            return t !== a[i - 1];
          });
        };

        IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
          var marginString = opt_rootMargin || "0px";
          var margins = marginString.split(/\s+/).map(function (margin) {
            var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);

            if (!parts) {
              throw new Error("rootMargin must be specified in pixels or percent");
            }

            return {
              value: parseFloat(parts[1]),
              unit: parts[2]
            };
          });
          margins[1] = margins[1] || margins[0];
          margins[2] = margins[2] || margins[0];
          margins[3] = margins[3] || margins[1];
          return margins;
        };

        IntersectionObserver.prototype._monitorIntersections = function (doc) {
          var win = doc.defaultView;

          if (!win) {
            return;
          }

          if (this._monitoringDocuments.indexOf(doc) != -1) {
            return;
          }

          var callback = this._checkForIntersections;
          var monitoringInterval = null;
          var domObserver = null;

          if (this.POLL_INTERVAL) {
            monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
          } else {
            addEvent(win, "resize", callback, true);
            addEvent(doc, "scroll", callback, true);

            if (this.USE_MUTATION_OBSERVER && "MutationObserver" in win) {
              domObserver = new win.MutationObserver(callback);
              domObserver.observe(doc, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
              });
            }
          }

          this._monitoringDocuments.push(doc);

          this._monitoringUnsubscribes.push(function () {
            var win2 = doc.defaultView;

            if (win2) {
              if (monitoringInterval) {
                win2.clearInterval(monitoringInterval);
              }

              removeEvent(win2, "resize", callback, true);
            }

            removeEvent(doc, "scroll", callback, true);

            if (domObserver) {
              domObserver.disconnect();
            }
          });

          var rootDoc = this.root && (this.root.ownerDocument || this.root) || document2;

          if (doc != rootDoc) {
            var frame = getFrameElement(doc);

            if (frame) {
              this._monitorIntersections(frame.ownerDocument);
            }
          }
        };

        IntersectionObserver.prototype._unmonitorIntersections = function (doc) {
          var index = this._monitoringDocuments.indexOf(doc);

          if (index == -1) {
            return;
          }

          var rootDoc = this.root && (this.root.ownerDocument || this.root) || document2;

          var hasDependentTargets = this._observationTargets.some(function (item) {
            var itemDoc = item.element.ownerDocument;

            if (itemDoc == doc) {
              return true;
            }

            while (itemDoc && itemDoc != rootDoc) {
              var frame2 = getFrameElement(itemDoc);
              itemDoc = frame2 && frame2.ownerDocument;

              if (itemDoc == doc) {
                return true;
              }
            }

            return false;
          });

          if (hasDependentTargets) {
            return;
          }

          var unsubscribe = this._monitoringUnsubscribes[index];

          this._monitoringDocuments.splice(index, 1);

          this._monitoringUnsubscribes.splice(index, 1);

          unsubscribe();

          if (doc != rootDoc) {
            var frame = getFrameElement(doc);

            if (frame) {
              this._unmonitorIntersections(frame.ownerDocument);
            }
          }
        };

        IntersectionObserver.prototype._unmonitorAllIntersections = function () {
          var unsubscribes = this._monitoringUnsubscribes.slice(0);

          this._monitoringDocuments.length = 0;
          this._monitoringUnsubscribes.length = 0;

          for (var i = 0; i < unsubscribes.length; i++) {
            unsubscribes[i]();
          }
        };

        IntersectionObserver.prototype._checkForIntersections = function () {
          if (!this.root && crossOriginUpdater && !crossOriginRect) {
            return;
          }

          var rootIsInDom = this._rootIsInDom();

          var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

          this._observationTargets.forEach(function (item) {
            var target = item.element;
            var targetRect = getBoundingClientRect(target);

            var rootContainsTarget = this._rootContainsTarget(target);

            var oldEntry = item.entry;

            var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, targetRect, rootRect);

            var rootBounds = null;

            if (!this._rootContainsTarget(target)) {
              rootBounds = getEmptyRect();
            } else if (!crossOriginUpdater || this.root) {
              rootBounds = rootRect;
            }

            var newEntry = item.entry = new IntersectionObserverEntry({
              time: now(),
              target: target,
              boundingClientRect: targetRect,
              rootBounds: rootBounds,
              intersectionRect: intersectionRect
            });

            if (!oldEntry) {
              this._queuedEntries.push(newEntry);
            } else if (rootIsInDom && rootContainsTarget) {
              if (this._hasCrossedThreshold(oldEntry, newEntry)) {
                this._queuedEntries.push(newEntry);
              }
            } else {
              if (oldEntry && oldEntry.isIntersecting) {
                this._queuedEntries.push(newEntry);
              }
            }
          }, this);

          if (this._queuedEntries.length) {
            this._callback(this.takeRecords(), this);
          }
        };

        IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, targetRect, rootRect) {
          if (window.getComputedStyle(target).display == "none") return;
          var intersectionRect = targetRect;
          var parent = getParentNode(target);
          var atRoot = false;

          while (!atRoot && parent) {
            var parentRect = null;
            var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};
            if (parentComputedStyle.display == "none") return null;

            if (parent == this.root || parent.nodeType == 9) {
              atRoot = true;

              if (parent == this.root || parent == document2) {
                if (crossOriginUpdater && !this.root) {
                  if (!crossOriginRect || crossOriginRect.width == 0 && crossOriginRect.height == 0) {
                    parent = null;
                    parentRect = null;
                    intersectionRect = null;
                  } else {
                    parentRect = crossOriginRect;
                  }
                } else {
                  parentRect = rootRect;
                }
              } else {
                var frame = getParentNode(parent);
                var frameRect = frame && getBoundingClientRect(frame);

                var frameIntersect = frame && this._computeTargetAndRootIntersection(frame, frameRect, rootRect);

                if (frameRect && frameIntersect) {
                  parent = frame;
                  parentRect = convertFromParentRect(frameRect, frameIntersect);
                } else {
                  parent = null;
                  intersectionRect = null;
                }
              }
            } else {
              var doc = parent.ownerDocument;

              if (parent != doc.body && parent != doc.documentElement && parentComputedStyle.overflow != "visible") {
                parentRect = getBoundingClientRect(parent);
              }
            }

            if (parentRect) {
              intersectionRect = computeRectIntersection(parentRect, intersectionRect);
            }

            if (!intersectionRect) break;
            parent = parent && getParentNode(parent);
          }

          return intersectionRect;
        };

        IntersectionObserver.prototype._getRootRect = function () {
          var rootRect;

          if (this.root && !isDoc(this.root)) {
            rootRect = getBoundingClientRect(this.root);
          } else {
            var doc = isDoc(this.root) ? this.root : document2;
            var html = doc.documentElement;
            var body = doc.body;
            rootRect = {
              top: 0,
              left: 0,
              right: html.clientWidth || body.clientWidth,
              width: html.clientWidth || body.clientWidth,
              bottom: html.clientHeight || body.clientHeight,
              height: html.clientHeight || body.clientHeight
            };
          }

          return this._expandRectByRootMargin(rootRect);
        };

        IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
          var margins = this._rootMarginValues.map(function (margin, i) {
            return margin.unit == "px" ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
          });

          var newRect = {
            top: rect.top - margins[0],
            right: rect.right + margins[1],
            bottom: rect.bottom + margins[2],
            left: rect.left - margins[3]
          };
          newRect.width = newRect.right - newRect.left;
          newRect.height = newRect.bottom - newRect.top;
          return newRect;
        };

        IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {
          var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
          var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;
          if (oldRatio === newRatio) return;

          for (var i = 0; i < this.thresholds.length; i++) {
            var threshold = this.thresholds[i];

            if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
              return true;
            }
          }
        };

        IntersectionObserver.prototype._rootIsInDom = function () {
          return !this.root || containsDeep(document2, this.root);
        };

        IntersectionObserver.prototype._rootContainsTarget = function (target) {
          var rootDoc = this.root && (this.root.ownerDocument || this.root) || document2;
          return containsDeep(rootDoc, target) && (!this.root || rootDoc == target.ownerDocument);
        };

        IntersectionObserver.prototype._registerInstance = function () {
          if (registry.indexOf(this) < 0) {
            registry.push(this);
          }
        };

        IntersectionObserver.prototype._unregisterInstance = function () {
          var index = registry.indexOf(this);
          if (index != -1) registry.splice(index, 1);
        };

        function now() {
          return window.performance && performance.now && performance.now();
        }

        function throttle(fn, timeout) {
          var timer = null;
          return function () {
            if (!timer) {
              timer = setTimeout(function () {
                fn();
                timer = null;
              }, timeout);
            }
          };
        }

        function addEvent(node, event, fn, opt_useCapture) {
          if (typeof node.addEventListener == "function") {
            node.addEventListener(event, fn, opt_useCapture || false);
          } else if (typeof node.attachEvent == "function") {
            node.attachEvent("on" + event, fn);
          }
        }

        function removeEvent(node, event, fn, opt_useCapture) {
          if (typeof node.removeEventListener == "function") {
            node.removeEventListener(event, fn, opt_useCapture || false);
          } else if (typeof node.detatchEvent == "function") {
            node.detatchEvent("on" + event, fn);
          }
        }

        function computeRectIntersection(rect1, rect2) {
          var top = Math.max(rect1.top, rect2.top);
          var bottom = Math.min(rect1.bottom, rect2.bottom);
          var left = Math.max(rect1.left, rect2.left);
          var right = Math.min(rect1.right, rect2.right);
          var width = right - left;
          var height = bottom - top;
          return width >= 0 && height >= 0 && {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            width: width,
            height: height
          } || null;
        }

        function getBoundingClientRect(el) {
          var rect;

          try {
            rect = el.getBoundingClientRect();
          } catch (err) {}

          if (!rect) return getEmptyRect();

          if (!(rect.width && rect.height)) {
            rect = {
              top: rect.top,
              right: rect.right,
              bottom: rect.bottom,
              left: rect.left,
              width: rect.right - rect.left,
              height: rect.bottom - rect.top
            };
          }

          return rect;
        }

        function getEmptyRect() {
          return {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: 0,
            height: 0
          };
        }

        function ensureDOMRect(rect) {
          if (!rect || "x" in rect) {
            return rect;
          }

          return {
            top: rect.top,
            y: rect.top,
            bottom: rect.bottom,
            left: rect.left,
            x: rect.left,
            right: rect.right,
            width: rect.width,
            height: rect.height
          };
        }

        function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
          var top = parentIntersectionRect.top - parentBoundingRect.top;
          var left = parentIntersectionRect.left - parentBoundingRect.left;
          return {
            top: top,
            left: left,
            height: parentIntersectionRect.height,
            width: parentIntersectionRect.width,
            bottom: top + parentIntersectionRect.height,
            right: left + parentIntersectionRect.width
          };
        }

        function containsDeep(parent, child) {
          var node = child;

          while (node) {
            if (node == parent) return true;
            node = getParentNode(node);
          }

          return false;
        }

        function getParentNode(node) {
          var parent = node.parentNode;

          if (node.nodeType == 9 && node != document2) {
            return getFrameElement(node);
          }

          if (parent && parent.assignedSlot) {
            parent = parent.assignedSlot.parentNode;
          }

          if (parent && parent.nodeType == 11 && parent.host) {
            return parent.host;
          }

          return parent;
        }

        function isDoc(node) {
          return node && node.nodeType === 9;
        }

        window.IntersectionObserver = IntersectionObserver;
        window.IntersectionObserverEntry = IntersectionObserverEntry;
      })();
    }
  }); // node_modules/focus-visible/dist/focus-visible.js


  var require_focus_visible = __commonJS({
    "node_modules/focus-visible/dist/focus-visible.js": function node_modulesFocusVisibleDistFocusVisibleJs(exports, module) {
      (function (global2, factory) {
        _typeof(exports) === "object" && typeof module !== "undefined" ? factory() : typeof define === "function" && define.amd ? define(factory) : factory();
      })(exports, function () {
        "use strict";

        function applyFocusVisiblePolyfill(scope) {
          var hadKeyboardEvent = true;
          var hadFocusVisibleRecently = false;
          var hadFocusVisibleRecentlyTimeout = null;
          var inputTypesAllowlist = {
            text: true,
            search: true,
            url: true,
            tel: true,
            email: true,
            password: true,
            number: true,
            date: true,
            month: true,
            week: true,
            time: true,
            datetime: true,
            "datetime-local": true
          };

          function isValidFocusTarget(el) {
            if (el && el !== document && el.nodeName !== "HTML" && el.nodeName !== "BODY" && "classList" in el && "contains" in el.classList) {
              return true;
            }

            return false;
          }

          function focusTriggersKeyboardModality(el) {
            var type = el.type;
            var tagName = el.tagName;

            if (tagName === "INPUT" && inputTypesAllowlist[type] && !el.readOnly) {
              return true;
            }

            if (tagName === "TEXTAREA" && !el.readOnly) {
              return true;
            }

            if (el.isContentEditable) {
              return true;
            }

            return false;
          }

          function addFocusVisibleClass(el) {
            if (el.classList.contains("focus-visible")) {
              return;
            }

            el.classList.add("focus-visible");
            el.setAttribute("data-focus-visible-added", "");
          }

          function removeFocusVisibleClass(el) {
            if (!el.hasAttribute("data-focus-visible-added")) {
              return;
            }

            el.classList.remove("focus-visible");
            el.removeAttribute("data-focus-visible-added");
          }

          function onKeyDown(e) {
            if (e.metaKey || e.altKey || e.ctrlKey) {
              return;
            }

            if (isValidFocusTarget(scope.activeElement)) {
              addFocusVisibleClass(scope.activeElement);
            }

            hadKeyboardEvent = true;
          }

          function onPointerDown(e) {
            hadKeyboardEvent = false;
          }

          function onFocus(e) {
            if (!isValidFocusTarget(e.target)) {
              return;
            }

            if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
              addFocusVisibleClass(e.target);
            }
          }

          function onBlur(e) {
            if (!isValidFocusTarget(e.target)) {
              return;
            }

            if (e.target.classList.contains("focus-visible") || e.target.hasAttribute("data-focus-visible-added")) {
              hadFocusVisibleRecently = true;
              window.clearTimeout(hadFocusVisibleRecentlyTimeout);
              hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
                hadFocusVisibleRecently = false;
              }, 100);
              removeFocusVisibleClass(e.target);
            }
          }

          function onVisibilityChange(e) {
            if (document.visibilityState === "hidden") {
              if (hadFocusVisibleRecently) {
                hadKeyboardEvent = true;
              }

              addInitialPointerMoveListeners();
            }
          }

          function addInitialPointerMoveListeners() {
            document.addEventListener("mousemove", onInitialPointerMove);
            document.addEventListener("mousedown", onInitialPointerMove);
            document.addEventListener("mouseup", onInitialPointerMove);
            document.addEventListener("pointermove", onInitialPointerMove);
            document.addEventListener("pointerdown", onInitialPointerMove);
            document.addEventListener("pointerup", onInitialPointerMove);
            document.addEventListener("touchmove", onInitialPointerMove);
            document.addEventListener("touchstart", onInitialPointerMove);
            document.addEventListener("touchend", onInitialPointerMove);
          }

          function removeInitialPointerMoveListeners() {
            document.removeEventListener("mousemove", onInitialPointerMove);
            document.removeEventListener("mousedown", onInitialPointerMove);
            document.removeEventListener("mouseup", onInitialPointerMove);
            document.removeEventListener("pointermove", onInitialPointerMove);
            document.removeEventListener("pointerdown", onInitialPointerMove);
            document.removeEventListener("pointerup", onInitialPointerMove);
            document.removeEventListener("touchmove", onInitialPointerMove);
            document.removeEventListener("touchstart", onInitialPointerMove);
            document.removeEventListener("touchend", onInitialPointerMove);
          }

          function onInitialPointerMove(e) {
            if (e.target.nodeName && e.target.nodeName.toLowerCase() === "html") {
              return;
            }

            hadKeyboardEvent = false;
            removeInitialPointerMoveListeners();
          }

          document.addEventListener("keydown", onKeyDown, true);
          document.addEventListener("mousedown", onPointerDown, true);
          document.addEventListener("pointerdown", onPointerDown, true);
          document.addEventListener("touchstart", onPointerDown, true);
          document.addEventListener("visibilitychange", onVisibilityChange, true);
          addInitialPointerMoveListeners();
          scope.addEventListener("focus", onFocus, true);
          scope.addEventListener("blur", onBlur, true);

          if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
            scope.host.setAttribute("data-js-focus-visible", "");
          } else if (scope.nodeType === Node.DOCUMENT_NODE) {
            document.documentElement.classList.add("js-focus-visible");
            document.documentElement.setAttribute("data-js-focus-visible", "");
          }
        }

        if (typeof window !== "undefined" && typeof document !== "undefined") {
          window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;
          var event;

          try {
            event = new CustomEvent("focus-visible-polyfill-ready");
          } catch (error) {
            event = document.createEvent("CustomEvent");
            event.initCustomEvent("focus-visible-polyfill-ready", false, false, {});
          }

          window.dispatchEvent(event);
        }

        if (typeof document !== "undefined") {
          applyFocusVisiblePolyfill(document);
        }
      });
    }
  }); // __assets/htdocs/hotels/anniversary/js/script.js


  var import_from = __toModule(require_from()); // __assets/_libs/script/index.ts


  var import_object_fit_images = __toModule(require_ofi_common_js()); // __assets/_libs/script/bugs/index.ts


  var ua = navigator.userAgent;
  var bugs_default = {
    webkitBug137730: function webkitBug137730() {
      var detection = /iphone|ipad|ipod/i.test(ua) && /version\/(10|9|8)\./i.test(ua);

      if (detection) {
        document.body.setAttribute("webkitBug137730", "");
      }
    }
  }; // __assets/_libs/script/config.ts

  var breakpointSm = 768;

  var __smLte = "screen and (max-width: ".concat(breakpointSm - 1, "px)"); // __assets/_libs/script/index.ts


  require_intersection_observer();
  require_focus_visible();

  var general = function general() {
    var filteredImgs = Array.from(document.querySelectorAll("img")).filter(function (el) {
      var _a;

      return ((_a = el.parentNode) == null ? void 0 : _a.className) !== "bgt-gallery__img";
    });
    window.objectFitImages = import_object_fit_images.default;
    window.objectFitImages(filteredImgs);
    bugs_default.webkitBug137730();
  };

  var script_default = function script_default(main) {
    if (document.readyState !== "loading") {
      general();
      main();
    } else {
      window.addEventListener("DOMContentLoaded", function () {
        general();
        main();
      });
    }
  }; // __assets/htdocs/hotels/anniversary/js/script.js


  script_default(function () {
    matchMedia(__smLte).addListener(function (media) {
      if (media.matches) {} else {}
    });
  });
  $(window).on("load scroll", function () {
    var box = $(".c-page-animation__fadein");
    var animated = "c-page-animation__in";
    box.each(function () {
      var boxOffset = $(this).offset().top;
      var scrollPos = $(window).scrollTop();
      var wh = $(window).height();

      if (scrollPos > boxOffset - wh + 100) {
        $(this).addClass(animated);
      }
    });
  });
  $(window).on("load scroll", function () {
    var box = $(".c-page-animation__fadeup");
    var animated = "c-page-animation__up";
    box.each(function () {
      var boxOffset = $(this).offset().top;
      var scrollPos = $(window).scrollTop();
      var wh = $(window).height();

      if (scrollPos > boxOffset - wh + 100) {
        $(this).addClass(animated);
      }
    });
  });
  $(window).on("load scroll", function () {
    var box = $(".c-page-animation__fadeinright");
    var animated = "c-page-animation__right";
    box.each(function () {
      var boxOffset = $(this).offset().top;
      var scrollPos = $(window).scrollTop();
      var wh = $(window).height();

      if (scrollPos > boxOffset - wh + 100) {
        $(this).addClass(animated);
      }
    });
  });
  $(window).on("load scroll", function () {
    var box = $(".c-page-animation__fadeinleft");
    var animated = "c-page-animation__left";
    box.each(function () {
      var boxOffset = $(this).offset().top;
      var scrollPos = $(window).scrollTop();
      var wh = $(window).height();

      if (scrollPos > boxOffset - wh + 100) {
        $(this).addClass(animated);
      }
    });
  });
  $(function () {
    $('.c-page-home-scene__content-link a[href^="#"]').click(function () {
      var windowWidth = $(window).width();
      var windowSm = 768;
      var adjust = 0;
      var spjust = -200;
      var speed = 500;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? "html" : href);
      var position = target.offset().top + adjust;
      var spposition = target.offset().top + spjust;

      if (windowWidth <= windowSm) {
        $("body,html").animate({
          scrollTop: spposition
        }, speed, "swing");
        return false;
      } else {
        $("body,html").animate({
          scrollTop: position
        }, speed, "swing");
        return false;
      }
    });
  });
  $(".c-hero__img-slider").slick({
    fade: true,
    autoplay: true,
    autoplaySpeed: 3e3,
    speed: 2e3,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false
  });
  $(".c-page-home-scene__content-img-slider").slick({
    fade: true,
    autoplay: true,
    autoplaySpeed: 3e3,
    speed: 3e3,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false
  });
  $(".c-page-home-stay__content-img-slider").slick({
    fade: true,
    autoplay: true,
    autoplaySpeed: 3e3,
    speed: 2e3,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false
  });
})();
/*! npm.im/object-fit-images 3.2.4 */